export enum PaymentStatus {
    SUCCESS = 'success',
    ERROR = 'error',
}
